import { Builder } from "flatbuffers";
import { TrackedEvent } from "./tracked-event";
import {
  SkeletalJointWireT,
  SkeletalPositionWire,
  SkeletalPositionWireT
} from "../../flatbuffers/mannequin";
import { BallPolynomial } from "./ball-polynomial";

export interface SkeletalData {
  skeletalData: {
    frames: SkeletalFrame[];
  };
}

export interface SkeletalStructure {
  [key: string]: string[];
}

export interface PositionXYZ {
  x: number;
  y: number;
  z: number;
}

export interface SkeletalPosition {
  positionId: number;
  track_id: number;
  playerId?: number;
  joints: {
    id: number;
    x: number;
    y: number;
    z: number;
  }[];
}

export interface InferredBatPosition {
  head_position: PositionXYZ;
  handle_position: PositionXYZ;
}

export interface SkeletalFrame {
  positions: SkeletalPosition[];
  ballPosition?: PositionXYZ;
  inferredBat?: InferredBatPosition;
  trackedEvents?: TrackedEvent[];
  ballPolynomials?: BallPolynomial[];
  timeStamp: string;
}

export class SkeletalPositionSerializer {
  static serializeBinary(
    position: SkeletalPosition,
    builder: Builder
  ): number | undefined {
    const positionObj = new SkeletalPositionWireT(
      position.positionId,
      position.track_id,
      position.playerId,
      position.joints.map(j => new SkeletalJointWireT(j.id, j.x, j.y, j.z))
    );

    return positionObj.pack(builder);
  }

  static deserializeBinary(posWire?: SkeletalPositionWire): SkeletalPosition | undefined {
    if (!posWire) return undefined;

    const unpacked = posWire.unpack();

    return {
      positionId: unpacked.positionId,
      track_id: unpacked.trackId,
      playerId: unpacked.playerId,
      joints: unpacked.joints,
    }
  }
}
